import { useState } from 'react';
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, CircularProgress, FormGroup, Radio, FormControlLabel, RadioGroup, Box, FormLabel, Typography, Autocomplete, Checkbox, FormHelperText } from '@mui/material';
import { addLatePaymentInterestApi, updateLatePaymentInterestApi } from '../apiService';
import { useSnackbar } from 'notistack';
import { globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { checkApiStatus } from '../../../../utils';
import { AttachementsUpload } from '../../../../shared_elements/components';
import { regexConstants } from '../../../../constants/regEx';
import { trackActivity } from '../../../../utils/mixpanel';
import { formatBytes } from '../../../../utils/fileUpload';
import { useDispatch, useSelector } from 'react-redux';
import { setFileUploadDetails } from '../../../../shared_elements/actions';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';

export const INTEREST_METHOD_OPTIONS = [{ label: 'Simple', value: 'is_simple' }, { label: 'Compound', value: 'is_compound' }];
export const COMPOUNDING_FREQUENCY_OPTIONS = [{ label: 'Daily', value: 'Daily' }, { label: 'Monthly', value: 'Monthly' }];


const LatePaymentIntCRU = ({ fileUpload, onToggleModal, addEditLatePaymentInt, getResponseBack, params, modeType, openAttachment }) => {
    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar();
    const { storageDetails } = useSelector((state) => state.leases);
    const [error, setError] = useState({});
    const [isLoading, setLoading] = useState(false);
    const [latePaymentIntData, setLatePaymentIntData] = useState({
        ...addEditLatePaymentInt?.data, is_annual: modeType === "add" ? true : addEditLatePaymentInt?.data?.is_annual, days_to_consider: modeType === "add" ? 365 : addEditLatePaymentInt?.data?.days_to_consider,
        is_simple: !addEditLatePaymentInt?.data?.is_compound,
        is_compound: Boolean(addEditLatePaymentInt?.data?.is_compound),
        compounding_frequency: addEditLatePaymentInt?.data?.is_compound ? addEditLatePaymentInt?.data?.compounding_frequency || null : null,
        restrict_interest_method: modeType === "add" ? false : Boolean(addEditLatePaymentInt?.data?.restrict_interest_method),
    });
    const [uploadfile, setUploadFile] = useState([]);

    const onFileChange = (data) => {
        setUploadFile(data);
        dispatch(setFileUploadDetails({ attachments: data }))
    }

    const onAddEditLastPaymentInt = () => {
        let validationInputs = {};
        const sofrValue = Number(latePaymentIntData?.sofr);
        validationInputs = {
            name: latePaymentIntData?.name ? "" : "Please enter Name",
            margin: latePaymentIntData?.margin === null || latePaymentIntData?.margin === undefined || latePaymentIntData?.margin === '' ? "Please enter Penalty" : "",
            sofr: latePaymentIntData?.sofr === null || latePaymentIntData?.sofr === undefined || latePaymentIntData?.sofr === '' ? "Please enter SOFR" : sofrValue <= 0 || Number.isNaN(sofrValue) ? "SOFR should be greater than 0" : "",
            days_to_consider: latePaymentIntData?.days_to_consider ? "" : "Please enter Days To Be Considered",
            interest_method: latePaymentIntData?.is_simple || latePaymentIntData?.is_compound ? "" : "Please select Interest Method",
            compounding_frequency: latePaymentIntData?.is_compound && !latePaymentIntData?.compounding_frequency ? "Select a compounding frequency." : "",
        };

        if (latePaymentIntData?.days_to_consider) {
            const days = Number(latePaymentIntData.days_to_consider);
            if (latePaymentIntData.is_annual === false && (days < 28 || days > 31)) {
                validationInputs.days_to_consider = "Only 28 to 31 days are allowed for Monthly";
            }
            if (latePaymentIntData.is_annual === true && (days < 360 || days > 366)) {
                validationInputs.days_to_consider = "Only 360 to 366 days are allowed for Annual";
            }
        }

        if (Object.keys(validationInputs).every((K) => { return validationInputs[K] === ""; })) {
            setLoading(true);
            let { interest_method, ...payload } = latePaymentIntData;
            payload = {
                ...payload,
                margin: payload.margin ?? 0,
                sofr: payload.sofr ?? 0,
                compounding_frequency: payload.is_compound ? payload.compounding_frequency : null,
                restrict_interest_method: Boolean(payload.restrict_interest_method)
            }
            if (latePaymentIntData.id) {
                globalPutService(updateLatePaymentInterestApi({ ...params, slug: latePaymentIntData?.slug }), payload)
                    .then(async (response) => {
                        if (checkApiStatus(response)) {
                            if (uploadfile?.length > 0) {
                                fileUpload(latePaymentIntData.slug, 'updated')
                            }
                            onToggleModal();
                            getResponseBack();
                            setLoading(false);
                            enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Late Payment Interest`, success_msg: response?.data?.message, item_id: latePaymentIntData?.id, payload: latePaymentIntData, response: response?.data })
                        } else {
                            setLoading(false);
                            enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } })
                            trackActivity('Item Edited', { page_title: `Edit Late Payment Interest`, error_msg: response?.data?.message, item_id: latePaymentIntData?.id, payload: latePaymentIntData, response: response?.data })
                        }
                    })
            } else {
                globalPostService(addLatePaymentInterestApi({ leaseSlug: params?.leaseSlug }), payload)
                    .then(async (response) => {
                        if (checkApiStatus(response)) {
                            if (uploadfile?.length > 0) {
                                fileUpload(response?.data?.data.slug, 'created')
                            }
                            onToggleModal();
                            getResponseBack();
                            setLoading(false);
                            enqueueSnackbar(response?.data?.message, {
                                variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }
                            })
                            trackActivity('Item Added', { page_title: `Add Late Payment Interest`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: latePaymentIntData, response: response?.data })
                        } else {
                            setLoading(false);
                            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } })
                            trackActivity('Item Added', { page_title: `Add Late Payment Interest`, error_msg: response?.data?.message, item_id: null, payload: latePaymentIntData, response: response?.data })
                        }
                    })
            }
        } else {
            setError(validationInputs);
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Late Payment Interest`, error_msg: validationInputs, })
        }
    }

    const handelInputChange = (key, value) => {
        let updatedData = { ...latePaymentIntData, [key]: value, };
        if (key === "is_annual") {
            updatedData.days_to_consider = value ? 365 : "";
            setError(prev => ({ ...prev, days_to_consider: "" }));
        }
        if (key === "interest_method") {
            updatedData = { ...latePaymentIntData, is_simple: value === 'is_simple', is_compound: value === 'is_compound' };
            if (value !== 'is_compound') updatedData.compounding_frequency = null;
            setError(prev => ({ ...prev, interest_method: "", compounding_frequency: "" }));
        }
        setLatePaymentIntData(updatedData);
    };

    const renderStaticDropdown = (key, label, options, placeholder, margin = 'normal') => (
        <Autocomplete
            disablePortal
            disableClearable
            options={options}
            disabled={modeType === "view"}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            getOptionLabel={(option) => option?.label || ""}
            value={options.find(option => option.value === latePaymentIntData?.[key]) || null}
            onChange={(_, value) => { handelInputChange(key, value?.value); setError(prev => ({ ...prev, [key]: "" })); }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    required
                    label={label}
                    placeholder={placeholder || `Select ${label}`}
                    margin={margin}
                    size='small'
                    error={Boolean(error[key])}
                    helperText={error[key]}
                    slotProps={{ inputLabel: { shrink: true } }}
                    disabled={modeType === "view"}
                />
            )}
        />
    );

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Late Payment Interest`, page_type: page_type, })
    }

    return (
        <>
            <Dialog aria-labelledby="customized-dilog-title" className="add-lease-dialog" maxWidth="md" fullWidth open={addEditLatePaymentInt.modal}>
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                    <Typography className="dialog-header-title">
                        {modeType === 'add' ? "Add Late Payment Interest" : modeType === 'edit' ? 'Edit Late Payment Interest' : 'View Late Payment Interest'}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id='name'
                                label="Name"
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 255 } }}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                required
                                error={error.name}
                                helperText={error.name}
                                // onChange={(e) => { handelInputChange("name", e.target.value.trimStart()); setError(prev => ({ ...prev, name: "" })); }}
                                onChange={(e) => {
                                    regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("name", e.target.value.trimStart()) : e.preventDefault()
                                    setError(prev => ({ ...prev, name: "" }));
                                }}
                                value={latePaymentIntData.name}
                                disabled={modeType === "view"}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="sofr"
                                label="SOFR(%)"
                                variant='outlined'
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 255 } }}
                                size='small'
                                margin='normal'
                                fullWidth
                                value={latePaymentIntData.sofr}
                                onChange={(e) => {
                                    regexConstants.percantageRegExp.test(e.target.value) || e.target.value === "" ? handelInputChange("sofr", e.target.value) : e.preventDefault()
                                    setError((prev) => ({ ...prev, sofr: "" }));
                                }}
                                disabled={modeType === "view"}
                                required
                                error={error.sofr}
                                helperText={error.sofr}
                            />
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="penalty"
                                label="Penalty(%)"
                                variant='outlined'
                                size='small'
                                margin='normal'
                                slotProps={{ inputLabel: { shrink: true } }}
                                fullWidth
                                value={latePaymentIntData.margin}
                                onChange={(e) => {
                                    regexConstants.percantageRegExp.test(e.target.value) || e.target.value === "" ? handelInputChange("margin", e.target.value) : e.preventDefault()
                                    setError((prev) => ({ ...prev, margin: "" }))
                                }}
                                disabled={modeType === "view"}
                                required
                                error={error.margin}
                                helperText={error.margin}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <TextField
                                id='interest_index'
                                label="Interest Index"
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 255 } }}
                                value={latePaymentIntData?.interest_index || ""}
                                onChange={(e) => {
                                    regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("interest_index", e.target.value.trimStart()) : e.preventDefault()
                                    setError(prev => ({ ...prev, interest_index: "" }));
                                }}
                                disabled={modeType === "view"}
                            />
                        </Grid>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px', padding: '10px', border: '1px solid #c7d9f3', borderRadius: '8px', background: '#eef5ff', mt: 1 }}>
                                <Typography component='div' sx={{ fontSize: '16px', fontWeight: 700, fontFamily: 'Roboto-Bold', color: '#163d6b' }}>Interest Method</Typography>
                                <RadioGroup row sx={{ gap: '24px' }}>
                                    {INTEREST_METHOD_OPTIONS.map((option) => (
                                        <FormControlLabel key={option.value} value={option.value} control={<Radio disableRipple onChange={() => handelInputChange('interest_method', option.value)} checked={Boolean(latePaymentIntData?.[option.value])} color="primary" size="small" />} label={option.label} disabled={modeType === "view"} />
                                    ))}
                                </RadioGroup>
                                {error.interest_method ? <FormHelperText error sx={{ m: 0 }}>{error.interest_method}</FormHelperText> : null}
                                {latePaymentIntData?.is_compound ?
                                    <Box sx={{ maxWidth: '340px', pt: '8px', pb: '4px' }}>
                                        {renderStaticDropdown("compounding_frequency", "Compounding Frequency", COMPOUNDING_FREQUENCY_OPTIONS, "Select frequency", "none")}
                                    </Box> : null}
                                <Box sx={{ borderTop: '1px solid #c7d9f3', pt: '6px' }}>
                                    <FormControlLabel label="Restrict Interest Method / Compounding Frequency on invoices for this contract" control={<Checkbox size='small' color='primary' checked={Boolean(latePaymentIntData?.restrict_interest_method)} onChange={(e) => handelInputChange('restrict_interest_method', e.target.checked)} />} disabled={modeType === "view"} />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <FormGroup className='disabled-checkbox-wrapper'>
                                <FormLabel sx={{ fontSize: '14px', color: '#000' }}>
                                    SOFR Applicable :
                                </FormLabel>
                                <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label">
                                    <FormControlLabel value={true} control={<Radio disableRipple onChange={() => handelInputChange('is_annual', true)} checked={latePaymentIntData.is_annual === true} color="primary" size="small" disabled={modeType === "view"} />} label="Annual" />
                                    <FormControlLabel value={false} control={<Radio disableRipple onChange={() => handelInputChange('is_annual', false)} checked={latePaymentIntData.is_annual === false} color="primary" size="small" />} label="Monthly" disabled={modeType === "view"} />
                                </RadioGroup>
                            </FormGroup>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id='daysToBeConsidered'
                                label="Days To Be Considered"
                                variant='outlined'
                                size='small'
                                margin='normal'
                                type='number'
                                slotProps={{
                                    inputLabel: { shrink: true },
                                    formHelperText: {
                                        sx: {
                                            backgroundColor: error.days_to_consider ? "transparent" : "#ffff96",
                                            display: 'inline-block',
                                            marginLeft: error.days_to_consider ? '14px' : 0,
                                            fontSize: error.days_to_consider ? '12px' : '9px',
                                            width: "fit-content",
                                            maxWidth: "100%",
                                            padding: error.days_to_consider ? 0 : "2px 4px",
                                        },
                                    }
                                }}
                                fullWidth
                                required
                                error={error.days_to_consider}
                                helperText={
                                    error.days_to_consider ? error.days_to_consider : latePaymentIntData.days_to_consider ? "" : latePaymentIntData.is_annual === false ? "Only 28 to 31 days are allowed for Monthly" : "Only 360 to 366 days are allowed for Annual"
                                }
                                disabled={modeType === "view"}
                                value={latePaymentIntData.days_to_consider}
                                onChange={(e) => { regexConstants.decimalnodotstart.test(e.target.value) ? handelInputChange("days_to_consider", e.target.value.trimStart()) : e.preventDefault(); setError(prev => ({ ...prev, days_to_consider: "" })); }}
                            />
                        </Grid>
                        {modeType === 'view' ?
                            <Grid item size={{ md: 12, xs: 12 }}>
                                <LessMoreTextFieldComp label='Description' value={latePaymentIntData?.description || ""} />
                            </Grid>
                            : <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    id='description'
                                    label="Description"
                                    variant='outlined'
                                    size='small'
                                    margin='normal'
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    fullWidth
                                    rows={3}
                                    multiline
                                    value={latePaymentIntData?.description || ""}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("description", e.target.value.trimStart()) : e.preventDefault()
                                        setError(prev => ({ ...prev, description: "" }));
                                    }}
                                />
                            </Grid>}
                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>
                            <Box className="responsive-buttons">
                                {
                                    latePaymentIntData?.id && latePaymentIntData?.attachments?.length ?
                                        <Button size='small' variant='outlined' color="primary" sx={{ marginBottom: '10px' }}
                                            onClick={() => { openAttachment(); handleItemClicked('ViewAttachments Button') }}>
                                            {`${latePaymentIntData.attachments.length}: Attachments`}
                                        </Button> : null
                                }
                                <Button className="available-space-btn" disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                            </Box>
                            {modeType === "view" ? null : <AttachementsUpload onFileChange={onFileChange} attachments={latePaymentIntData?.attachments} remainingStorage={storageDetails?.remaining_storage} />}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className="cancel-btn" variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }} disabled={isLoading}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null :
                        <Button variant='contained' size='small' className="btn-primary" onClick={() => { handleItemClicked('Save Button'); onAddEditLastPaymentInt() }} disabled={modeType === "view"}>
                            {isLoading ? <CircularProgress color='inherit' size={24} /> : "Save"}
                        </Button>}
                </DialogActions>
            </Dialog>
        </>

    )
}
export default LatePaymentIntCRU;